export class FilterCriteriaEDT {
    type;
	value;
	field;
}